export default function ModalEstoque({ modalEstoque, setModalEstoque, estoqueForm, setEstoqueForm, movimentarEstoque }) {
  if (!modalEstoque) return null;
  return (
    <div className="overlay-modal">
      <div style={{background:"#fff",borderRadius:8,padding:24,maxWidth:420,width:"90%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
        <div style={{fontSize:15,fontWeight:700,marginBottom:4}}>Movimentar Estoque</div>
        <div style={{fontSize:12,color:"var(--z-text-muted)",marginBottom:16}}>{modalEstoque.codigo} — {modalEstoque.nome}</div>
        <div style={{fontSize:13,marginBottom:16}}>
          Estoque atual: <strong className="text-blue">{parseFloat(modalEstoque.estoque||0).toLocaleString("pt-BR",{minimumFractionDigits:2})} {modalEstoque.unidade}</strong>
        </div>
        <div className="flex-row mb-12">
          {["ENTRADA","SAIDA","AJUSTE"].map(t=>(
            <button key={t} className={"btn "+(estoqueForm.tipo===t?"btn-primary":"btn-secondary")}
              style={{fontSize:12,flex:1}} onClick={()=>setEstoqueForm(f=>({...f,tipo:t}))}>
              {t==="ENTRADA"?"+ Entrada":t==="SAIDA"?"- Saida":"= Ajuste"}
            </button>
          ))}
        </div>
        <div className="form-group">
          <label className="form-label">Quantidade ({modalEstoque.unidade})</label>
          <input className="form-input" type="number" value={estoqueForm.quantidade}
            onChange={e=>setEstoqueForm(f=>({...f,quantidade:e.target.value}))} placeholder="0"/>
        </div>
        <div className="form-group">
          <label className="form-label">Descricao (opcional)</label>
          <input className="form-input" value={estoqueForm.descricao}
            onChange={e=>setEstoqueForm(f=>({...f,descricao:e.target.value}))} placeholder="Ex: Compra NF 1234"/>
        </div>
        {estoqueForm.tipo==="AJUSTE"&&<div style={{fontSize:11,color:"var(--z-text-muted)",marginBottom:8}}>Ajuste define o saldo diretamente para o valor informado.</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
          <button className="btn btn-secondary" onClick={()=>setModalEstoque(null)}>Cancelar</button>
          <button className="btn btn-primary" onClick={movimentarEstoque}>Confirmar</button>
        </div>
      </div>
    </div>
  );
}
